import { Component, OnInit, Input } from '@angular/core';
import { DocumentItem, Document } from '../../../../shared/sdk';
import { DocumentService } from '../../../../documents/document.service';

@Component({
  selector: '[app-document-view-item]',
  templateUrl: './document-view-item.component.html',
  styleUrls: ['./document-view-item.component.css']
})
export class DocumentViewItemComponent implements OnInit {
  @Input() item: DocumentItem;
  @Input() document: Document;
  @Input() locale: string;

  constructor(
    private documentService: DocumentService,
  ) { }

  ngOnInit() {
  }

  lod(data: any, field: string, l10nField?: string): string {
    return this.documentService.getLocalizedOrDefault(data, this.locale, field, l10nField);
  }

}
